import { FC } from 'react'
import Typography from '../typography'
import { LoaderWithTextContainer, PulsingDot } from './loaderWithText.styles'

type TLoaderWithTextProps = {
    text: string
    direction?: 'rtl' | 'ltr'
}

const LoaderWithText: FC<TLoaderWithTextProps> = ({
    text,
    direction = 'rtl',
}) => {
    return (
        <LoaderWithTextContainer
            className="loader-with-text"
            direction={direction}
        >
            <PulsingDot data-testid="loader-pulsing-dot" />
            <Typography variant="xs-regular">{text}</Typography>
        </LoaderWithTextContainer>
    )
}

export default LoaderWithText
